import { takeEvery, put, call } from "redux-saga/effects"
import { POST_AI_MARKUP_DATA, UPDATE_AI_MARKUP_DATA, GET_AI_MARKUP_DATA } from './actionTypes';
import { postMarkupDataSuccess, postMarkupDataFail, getMarkupDataSuccess, getMarkupDataFail } from './actions';
import { postNewInterviewDetails, getAimarkupDetails,putAimarkupDetails } from "../../../../helpers/fakebackend_helper"
import * as constClass from "../../../../common/constant/constantURL"

function* postAiMarkuphandler({ payload: { jsonData } }) {
  try {
    let url = constClass.REST_API_POST_AI_MARKUP_DATA;
    let responseJson = yield call(postNewInterviewDetails, url, jsonData);
    yield put(postMarkupDataSuccess(responseJson))
  }
  catch (error) {
    yield put(postMarkupDataFail(error))
  }
}

function* putAiMarkuphandler({ payload: { jsonData } }) {
  try {
    let url = constClass.REST_API_POST_AI_MARKUP_DATA;
    let responseJson = yield call(putAimarkupDetails, url, jsonData);
    yield put(postMarkupDataSuccess(responseJson))
  }
  catch (error) {
    yield put(postMarkupDataFail(error))
  }
}

function* getAiMarkuphandler({ payload: status }) {
  try {
    let url = constClass.REST_API_GET_AI_MARKUP_DATA;
    if( status !== undefined &&  status !== null &&  status === true){
      url = url+`?firstTimeLogin=true`
     }
    let responseJson = yield call(getAimarkupDetails, url);
    yield put(getMarkupDataSuccess(responseJson))
  }
  catch (error) {
    yield put(getMarkupDataFail(error))
  }
}

function* AiMarkupSaga() {
  yield takeEvery(POST_AI_MARKUP_DATA, postAiMarkuphandler);
  yield takeEvery(UPDATE_AI_MARKUP_DATA, putAiMarkuphandler)
  yield takeEvery(GET_AI_MARKUP_DATA, getAiMarkuphandler)
}
export default AiMarkupSaga 